import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-when-click-label-on-label',
  templateUrl: './modal-when-click-label-on-label.component.html',
  styleUrls: ['./modal-when-click-label-on-label.component.scss'],
  standalone: false,
})
export class ModalWhenClickLabelOnLabelComponent {
  @Input() marker;

  constructor(private router: Router) {}

  seeDetails(event) {
    if (event.target.tagName !== 'BUTTON') {
      this.router.navigate([`/property/${this.marker.id}/${this.marker.slug || 'addr'}`]);
    }
  }
}
